// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"96":"3313e70d","326":"e5cbd7fe","389":"440e4753","547":"ceddc73a","913":"b49a0bee","928":"f8c29a7d"}[chunkId] + ".css";
};